<template>
  <div>
    <!-- HEADER -->
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("invoice_print") }}</h4>
        </div>
      </div>

      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link to="/" class="btn btn-added">
              <span>Back</span>
            </router-link>
          </div>
        </li>
      </ul>
    </div>

    <!-- CARD -->
    <div class="card table-list-card p-3 bg-white fs-7">
      <form>
        <!-- SEARCH -->
        <div class="row mb-3">
          <div class="col-md-6 d-flex align-items-start">
            <label class="form-label me-3" style="width:130px;">
              {{ $t('select_voucher') }}:
            </label>

            <div class="flex-grow-1 position-relative">
              <input
                type="number"
                v-model="q"
                @input="searchVoucher"
                class="form-control"
                :placeholder="$t('search_voucher_by_id')"
                @keydown="handleKeysVoucher"
              />

              <!-- Results List -->
                <ul class="list-group list-group-flush">
                  <li
                    v-for="(voucher, index) in voucher_result"
                    :key="voucher.id"
                    class="list-group-item d-flex justify-content-between align-items-center"
                    :class="{ 'bg-primary text-white': index === itemIndex }"
                    style="padding: 10px; font-size: 0.95rem; cursor: pointer;"
                  >
                    <!-- Clickable Product Info -->
                    <div
                      class="flex-grow-1 d-flex flex-column"
                      @click="selectVoucher(voucher)"
                      style="cursor: pointer;"
                    >
                      <div class="d-flex align-items-center gap-2">
                        <!-- Voucher Info -->
                        <div class="d-flex flex-column">
                          <strong class="text-dark">{{ voucher.voucher_id }}</strong>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
            </div>
          </div>
        </div>

        <div
          id="invoice"
          v-if="results.length && selectedVoucher && invoiceStyle === 'Thermal(80mm)'"
          style="
            width:300px;
            font-family: monospace;
            font-size:12px;
            margin:auto;
            background:#fff;
            border:1px solid #ddd;
            padding:10px;

            max-height:500px;
            overflow-y:auto;
          "
        >

          <!-- HEADER -->
          <div style="text-align:center;">
            <div style="font-weight:bold;">Government of the People's Republic of Bangladesh</div>
            <div>National Board of Revenue</div>
            <div><b>Entrance Logic Systems</b></div>
            <div>400/1, West Kafrul, Mirpur</div>
            <div style="margin:5px 0;">------------------------------</div>
            <div style="font-weight:bold;">RETAIL INVOICE</div>
            <div style="margin:5px 0;">------------------------------</div>
          </div>

          <!-- INFO -->
          <div style="margin-top:5px;">
            <div style="display:flex; justify-content:space-between;">
              <span>Cashier:</span><span>L0000</span>
            </div>
            <div style="display:flex; justify-content:space-between;">
              <span>Terminal:</span><span>D00000</span>
            </div>
            <div style="display:flex; justify-content:space-between;">
              <span>Invoice:</span><span>{{ q }}</span>
            </div>
            <div style="display:flex; justify-content:space-between;">
              <span>Date:</span><span>{{ new Date().toLocaleString() }}</span>
            </div>
          </div>

          <div style="border-top:1px dashed #000; margin:5px 0;"></div>

          <!-- TABLE HEADER -->
          <div style="display:flex; font-weight:bold;">
            <div style="width:10%;">SL</div>
            <div style="width:40%;">Item</div>
            <div style="width:15%; text-align:right;">Unit</div>
            <div style="width:15%; text-align:right;">Qty</div>
            <div style="width:20%; text-align:right;">Taka</div>
          </div>

          <div style="border-top:1px dashed #000; margin:5px 0;"></div>

          <!-- ITEMS -->
          <div style="display:flex;" v-for="(item, index) in results" :key="item.id">

            <!-- NAME -->
            <div style="font-weight:500; width: 50%;">
              {{ index + 1 }}. {{ (item.item_name || '').substring(0,25) }}
            </div>

            <!-- VALUES -->
              <div style="width:15%; text-align:right;">{{ item.unit_price }}</div>
              <div style="width:15%; text-align:right;">{{ item.qty }}</div>
              <div style="width:20%; text-align:right;">{{ item.total_price }}</div>
          </div>

          <div style="border-top:1px dashed #000; margin:5px 0;"></div>

          <!-- SUMMARY -->
          <div style="text-align:right;">

            <div style="display:flex; justify-content:space-between;">
              <span>Sub Total</span>
              <span>{{ summary.sub_total }}</span>
            </div>

            <div style="display:flex; justify-content:space-between;">
              <span>Discount</span>
              <span>{{ summary.discount }}</span>
            </div>

            <div style="display:flex; justify-content:space-between;">
              <span>Tax</span>
              <span>{{ summary.vat }}</span>
            </div>

            <div style="border-top:1px dashed #000; margin:5px 0;"></div>

            <div style="display:flex; justify-content:space-between; font-weight:bold;">
              <span>Net Payable</span>
              <span>{{ summary.total }}</span>
            </div>

            <div style="display:flex; justify-content:space-between;">
              <span>Paid</span>
              <span>{{ summary.received }}</span>
            </div>

            <div style="display:flex; justify-content:space-between;">
              <span>Change</span>
              <span>{{ (summary.received || 0) - (summary.total || 0) }}</span>
            </div>

          </div>

          <div style="border-top:1px dashed #000; margin:5px 0;"></div>

          <!-- FOOTER -->
          <div style="text-align:center;">
            <div>Thank you for shopping!</div>
            <div>Visit Again</div>
          </div>

        </div>

        <div
            v-if="invoiceStyle === 'A4' && results.length"
            id="invoice-a4"
            style="
              width:800px;
              margin:auto;
              font-family: Arial;
              font-size:13px;
              background:#fff;
              max-height:500px;
              overflow-y:auto;
              border:1px solid #ddd;
              padding:15px;
            "
          >

            <!-- HEADER -->
            <table style="width:100%; border:1px solid #000; border-collapse:collapse;">
              <tr>
                <td style="width:60%; padding:10px; vertical-align:top;">
                  <b>Entrance Logic Systems</b><br/>
                  400/1, West Kafrul, Mirpur<br/>
                  Phone: +880 1913-509222<br/>
                  Email: info@entrancelogic.com
                </td>

                <td style="width:40%; padding:10px; vertical-align:top; border-left:1px solid #000;">
                  <b>INVOICE</b><br/><br/>
                  Invoice No: {{ q }}<br/>
                  Date: {{ new Date().toLocaleString() }}<br/>
                  Status: Approved
                </td>
              </tr>
            </table>

            <br/>

            <!-- CUSTOMER INFO -->
            <table style="width:100%; border-collapse:collapse;">
              <tr>
                <td style="width:10%; background:#f5f5f5; border:1px solid #ccc;">To:</td>
                <td style="width:90%; border:1px solid #ccc;">{{ invoicePayload.customer.name }}</td>
              </tr>
              <tr>
                <td style="background:#f5f5f5; border:1px solid #ccc;">Contact:</td>
                <td style="border:1px solid #ccc;">{{ invoicePayload.customer.phone }}</td>
              </tr>
              <tr>
                <td style="background:#f5f5f5; border:1px solid #ccc;">Address:</td>
                <td style="border:1px solid #ccc;">{{ invoicePayload.customer.address }}</td>
              </tr>
            </table>

            <br/>

            <!-- PRODUCT TABLE -->
            <table style="width:100%; border-collapse:collapse;">
              <thead>
                <tr style="background:#e0e0e0; text-align:center;">
                  <th style="border:1px solid #ccc;">#</th>
                  <th style="border:1px solid #ccc;">Product Name</th>
                  <th style="border:1px solid #ccc;">Qty</th>
                  <th style="border:1px solid #ccc;">Unit Price</th>
                  <th style="border:1px solid #ccc;">Discount</th>
                  <th style="border:1px solid #ccc;">Amount</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, i) in results" :key="i">
                  <td style="border:1px solid #ccc; text-align:center;">{{ i + 1 }}</td>
                  <td style="border:1px solid #ccc;">{{ item.item_name }}</td>
                  <td style="border:1px solid #ccc; text-align:right;">{{ item.qty }}</td>
                  <td style="border:1px solid #ccc; text-align:right;">{{ item.unit_price }}</td>
                  <td style="border:1px solid #ccc; text-align:right;">0.00</td>
                  <td style="border:1px solid #ccc; text-align:right;">{{ item.total_price }}</td>
                </tr>
              </tbody>
            </table>

            <br/>

            <!-- SUMMARY -->
            <div style="display:flex; justify-content:flex-end;">
              <table style="width:300px; border-collapse:collapse;">
                <tr>
                  <td>Total Quantity</td>
                  <td style="text-align:right;">
                    {{ results.reduce((a,b)=>a + Number(b.qty),0) }}
                  </td>
                </tr>

                <tr>
                  <td>Total Amount</td>
                  <td style="text-align:right;">{{ summary.sub_total }}</td>
                </tr>

                <tr>
                  <td>Rounding</td>
                  <td style="text-align:right;">0.00</td>
                </tr>

                <tr style="font-weight:bold; background:#f5f5f5;">
                  <td>Grand Total</td>
                  <td style="text-align:right;">{{ summary.total }}</td>
                </tr>
              </table>
            </div>

            <br/>

            <!-- IN WORD -->
            <p><b>In Word:</b> {{ amountInWords }}</p>

            <br/><br/>

            <!-- SIGNATURE -->
            <table style="width:100%; border:1px solid #000; border-collapse:collapse; text-align:center;">
              <tr style="height:60px;">
                <td style="border-right:1px solid #000;"></td>
                <td style="border-right:1px solid #000;"></td>
                <td></td>
              </tr>

              <tr>
                <td style="border-top:1px solid #ccc;">Received By</td>
                <td style="border-top:1px solid #ccc;">Checked By</td>
                <td style="border-top:1px solid #ccc;">Authorized By</td>
              </tr>
            </table>

            <br/>

            <!-- FOOTER -->
            <p>* Goods once sold are not refundable or exchangeable.</p>
            <p>* Warranty does not cover physical or liquid damage.</p>
            <p>* Invoice must be shown for warranty claim.</p>
        </div>

        <!-- BUTTONS -->
        <div class="text-end mt-3">
          <button type="button" class="btn btn-secondary me-2" @click="reset">
            Cancel
          </button>

          <button type="button" class="btn btn-primary" @click="printInvoice">
            Print
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiUrls from "@/urls";
import { useToast } from "vue-toastification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      q: "",
      voucher_result: [],
      selectedVoucher: null,
      results: [],
      summary: {},
      itemIndex: 0,
      invoicePayload: null,
      invoiceStyle: null,
    };
  },

  computed: {
    amountInWords() {
      // simple fallback (you can improve later)
      return this.summary.total + " Taka Only";
    }
  },

  methods: {
    async searchVoucher() {
      if (!this.q) {
        this.voucher_result = [];
        this.results = [];
        this.summary = {};
        return;
      }

      try {
        const res = await this.$axios.get(apiUrls.invoice_print.get, {
          params: { voucher_id: this.q },
        });

        // If backend gives list
        if (res.data.results) {
          this.voucher_result = res.data.results;
        } else {
          // fallback
          this.voucher_result = [];
        }

        this.itemIndex = 0;

      } catch (e) {
        this.voucher_result = [];
      }
    },

    async fetchInvoice(voucher_id) {
      try {
        const res = await this.$axios.get(apiUrls.invoice_print.get, {
          params: { voucher_id },
        });

        this.results = res.data.items || [];
        this.summary = res.data.summary || {};
        this.invoiceStyle = res.data.invoice_style;

        this.invoicePayload = res.data;

      } catch (e) {
        this.results = [];
        this.summary = {};
        this.invoicePayload = null;
        this.invoiceStyle = null;
      }
    },

    async selectVoucher(voucher) {
      this.selectedVoucher = voucher;
      this.q = voucher.voucher_id;

      this.voucher_result = [];
      this.itemIndex = 0;

      await this.fetchInvoice(voucher.voucher_id);
    },

    handleKeysVoucher(e) {
      if (e.key === "ArrowDown") {
        this.itemIndex = Math.min(this.itemIndex + 1, this.voucher_result.length - 1);
        e.preventDefault();
      } else if (e.key === "ArrowUp") {
        this.itemIndex = Math.max(this.itemIndex - 1, 0);
        e.preventDefault();
      } else if (e.key === "Enter") {
        if (this.voucher_result[this.itemIndex]) {
          this.selectVoucher(this.voucher_result[this.itemIndex]);
        }
        e.preventDefault();
      }
    },

    async printInvoice() {
      if (!this.invoicePayload) {
        this.toast.warning("Select voucher first");
        return;
      }

      try {
        await this.$axios.post(
          '/direct/print/',
          this.invoicePayload
        );

        this.toast.success("Printed successfully");

      } catch (e) {
        this.toast.error("Print failed");
      }
    },

    reset() {
      this.q = "";
      this.results = [];
      this.summary = {};
      this.voucher_result = [];
      this.invoiceStyle = null;
    },
  },
};
</script>

<style scoped>
@media print {
  body * {
    visibility: hidden;
  }

  #invoice, #invoice * {
    visibility: visible;
  }

  #invoice {
    position: absolute;
    left: 0;
    top: 0;
    width: 80mm;
  }
}
</style>

